import { createWithEqualityFn as create } from 'zustand/traditional';
import type { PlainOpeningHoursDto } from '@ordr-as/menu-builder-types/epos';

interface OpeningHoursActions {
  setAllOpeningHours: (data: Record<string, PlainOpeningHoursDto[]>) => void;
  setServerTimeOffset: (offsetMs: number) => void;
  clear: () => void;
}

export interface OpeningHoursState {
  // Opening hours indexed by sectionId for future cart validation
  sectionOpeningHours: Record<string, PlainOpeningHoursDto[]>;
  serverTimeOffsetMs: number;
  actions: OpeningHoursActions;
}

export const useOpeningHoursStore = create<OpeningHoursState>()((set) => ({
  sectionOpeningHours: {},
  serverTimeOffsetMs: 0,

  actions: {
    setAllOpeningHours: (data) => set({ sectionOpeningHours: data }),
    setServerTimeOffset: (offsetMs) => set({ serverTimeOffsetMs: offsetMs }),
    clear: () => set({ sectionOpeningHours: {}, serverTimeOffsetMs: 0 }),
  },
}));

export const useSectionOpeningHours = (sectionId: string) =>
  useOpeningHoursStore((state) => state.sectionOpeningHours[sectionId] ?? []);

export const useAllOpeningHours = () => useOpeningHoursStore((state) => state.sectionOpeningHours);
export const useOpeningHoursActions = () => useOpeningHoursStore((state) => state.actions);
export const useServerTimeOffsetMs = () => useOpeningHoursStore((state) => state.serverTimeOffsetMs);
